let bsParams = {

    type: '',     // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: '',     // 姓名
    gender: '',     // 性别（选择项）
    idNumber: '',     // 身份证号码
    job: '',     // 职务
    professionalOther: '',     // 职务其他
    politicalStatus: '',     // 政治面貌（选择项）
    culture: '',     // 文化程度（选择项）
    cellphone: '',     // 手机
    major: '',     // 专业
    professionalTitleSeries: '',     // 职称系列（选择项）
    titleLevel: '',     // 职称级别（选择项）

    professionalCertificateId: '',
    certificateSituation: '',     // 持有出版专业技术人员职业资格证书情况
    professionalCertificate: '',     // 职业资格证书文件名

    trainCertificateId: '',     // 岗位培训合格证书存放目录
    isTrainCertificate: '',     // 是否持有岗位培训合格证书
    trainCertificate: '',     // 岗位培训合格证书文件名


    id: '',     // id
    publishId: '',     // 出版单位ID
    publishMaterialId: '',     // publishMaterialId
    publishType: '',     // 根据单位性质，决定人员类型（比如1电子业务人员、2音像业务人员、3音像电子业务人员、4连续电子业务人员）

}

let idCard = (rule, val, callback) => {
    let pattern = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
    let reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

    if (val == '') {
        callback(new Error('请输入身份证号或军官证号'));
    } else if (val.length > 15) {
        if (!pattern.test(val)) {
            callback(new Error('身份证号错误'));
        } else {
            callback();
        }
    } else {
        if (!reg.test(val)) {
            callback(new Error('军官证号错误'));
        } else {
            callback();
        }
    }
};

let homePhone = (rule, val, callback) => {      //固话验证
    var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
    if (val == '') {
        callback(new Error('请输入电话'));
    } else if (!pattern.test(val)) {
        callback(new Error('电话格式错误！'));
    } else {
        callback();
    }
};

let zipCode = (rule, val, callback) => {      // 邮编验证
    var pattern = /(^[0-9]{6})$/;
    if (val == '') {
        callback(new Error('请输入单位邮编'));
    } else if (!pattern.test(val)) {
        callback(new Error('邮编格式错误！'));
    } else {
        callback();
    }
};

let mobelPhone = (rule, val, callback) => {      // 手机验证
    var pattern = /^1[0-9]{10}$/;
    if (val == '') {
        callback(new Error('请输入手机号'));
    } else if (!pattern.test(val)) {
        callback(new Error('手机号格式错误！'));
    } else {
        callback();
    }
};

let paramsRule = {

    type: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 姓名
    gender: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 性别（选择项）
    idNumber: [
        { validator: idCard, trigger: 'blur' },
    ],     // 身份证号码
    job: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 职务
    professionalOther: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],
    politicalStatus: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 政治面貌（选择项）
    culture: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 文化程度（选择项）
    cellphone: [
        { validator: mobelPhone, trigger: 'blur' },
    ],     // 手机
    major: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 专业
    professionalTitleSeries: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 职称系列（选择项）
    titleLevel: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 职称级别（选择项）

    certificateSituation: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 持有出版专业技术人员职业资格证书情况

    isTrainCertificate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 是否持有岗位培训合格证书

}

export { bsParams, paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsSEt4.js